
import { IonImg, IonThumbnail, IonItem, IonLabel } from "@ionic/vue";
import { Browser } from "@capacitor/browser";
import { PropType } from "vue";
import { PostModel } from "@/models/PostModel";

export default {
  name: "PostItem",
  components: {
    IonImg,
    IonThumbnail,
    IonItem,
    IonLabel,
  },
  props: {
    post: {
      type: Object as PropType<PostModel>,
      required: true,
    },
  },
  setup() {
    const openUrl = (url: string) => {
      Browser.open({
        url: url,
        windowName: "_target",
        toolbarColor: "#29323c",
      });
    };

    return { openUrl };
  },
};
